// import { info } from 'node-sass'
import { max } from 'jalali-moment'
import React from 'react'
// import { detectBrowser } from '../utils/useful'
import { ChromePicker } from 'react-color'
import { getBoundingClientRect } from '../../utils/functions'
import FixedView from '../FixedView'
import { checkTranslation, translate } from '../../utils/useful'

class AdvancedColorInput extends React.Component {

    state = {
        top: 0,
        left: 0,
        right: 0,
        opacity: 0,
        current: 'background',

    }



    handleClick = () => {
        this.setState({ opened: true })
        this.colorPicker.showView()
        //   console.log()
        // this.setState({ displayColorPicker: !this.state.displayColorPicker })
    };

    handleClose = () => {
        this.setState({ displayColorPicker: false })
    };

    handleOpen = () => {
        this.setState({ displayColorPicker: true })
    }



    componentWillUnmount() {
        this.hideView()


    }
    // showView = (cb) => {
    //     console.log("showView")
    //     setTimeout(() => {

    //         this.getBounding()



    //         // this.interval = setInterval(() => {
    //         //     this.getBounding()

    //         // }, 40);
    //         setTimeout(() => {

    //             let options = {
    //                 // root: this.props.nodeRef,
    //                 rootMargin: '0px',
    //                 threshold: 1.0
    //             }


    //             this.observer = new IntersectionObserver(this.callback, options);

    //             // console.log(this.props.nodeRef, this.props.id2)
    //             this.observer.observe(this.props.nodeRef);


    //             window.addEventListener('mouseup', this.checkHide, true)
    //             window.addEventListener('scroll', this.getBounding, true);

    //         }, 20);

    //     }, 10);

    // }

    callback = (entries, observer) => {
        entries.forEach((entry) => {
            if (!entry.isIntersecting) {
                this.hideView()
            }
        })
    }


    checkHide = (e) => {
        // console.log('hiiideee')
        if (e && this.view && !this.view.contains(e.target)) {
            this.hideView()
        }

    }



    hideView = () => {
        // console.log("hideView")

        if (this.observer) {
            this.observer.disconnect()
        }
        clearInterval(this.interval)
        window.removeEventListener('mouseup', this.hideView)
        window.removeEventListener('scroll', this.getBounding, true);



        // console.log("this.state.isOpen", this.state.isOpen)
        if (this.props.onHide && this.state.isOpen == true) {
            this.props.onHide()
        }
        this.setState({ opacity: 0 }, () => {
            // setTimeout(() => {
            this.setState({ isOpen: false })
            // }, 500);
        })
        // console.log("this.state.isOpen", this.state.isOpen)

    }

    getBounding = () => {
        // return
        if (this.props.nodeRef && this.view) {

            let topOffset = this.props.topOffset ?? 35
            let bottomOffset = this.props.bottomOffset ?? 0
            let rect = getBoundingClientRect(this.props.nodeRef)
            let indicatorBound = getBoundingClientRect(this.positionIndicator)
            // indicatorBound.left = 0
            // indicatorBound.top = 0
            // console.log(rect)
            // console.log(indicatorBound)

            // console.log(window.innerHeight)

            let windowTop = 0

            // if (detectBrowser() == 'Safari') {
            //     windowTop = indicatorBound.top > 0 ? indicatorBound.top : 0
            // }

            let spaceFromBottom = window.innerHeight - rect.bottom - windowTop - topOffset
            this.setState({ width: rect.width })

            // let spaceFromBottom = window.innerHeight - rect.top - windowTop - topOffset
            let spaceFromTop = rect.top + windowTop



            let top = rect.bottom - indicatorBound.top
            let left = rect.left - indicatorBound.left
            let maxHeight = this.props.maxHeight ?? 300
            let optimized = false
            if (this.content) {
                let contentBound = getBoundingClientRect(this.content)
                // console.log(contentBound)
                maxHeight = contentBound.height
                optimized = true
                // console.log('maxHeight')
                // console.log(maxHeight)

            }

            if (spaceFromBottom < maxHeight) {
                if (spaceFromBottom < spaceFromTop) {

                    // if (spaceFromTop - 10 > maxHeight) {
                    maxHeight = spaceFromTop > maxHeight ? maxHeight : (spaceFromTop - 10)
                    // }
                    top = top - bottomOffset - maxHeight - 8
                } else {
                    top = top + topOffset
                    maxHeight = spaceFromBottom - 10
                }
            } else {
                top = top + topOffset
            }

            // console.log('----')
            // console.log(maxHeight)
            // console.log(left)
            // console.log(spaceFromBottom)

            if (this.props.rightAlign && this.content) {
                let viewBound = getBoundingClientRect(this.content)
                // console.log(viewBound)
                left = left - viewBound.width + 30 + (this.props.xOffset ?? 0)
            } else {
                left = left - 10 - (this.props.xOffset ?? 0)
            }

            // console.log(left)

            this.setState({ top: top, left: left, maxHeight }, () => {

                if (!this.state.isOpen) {
                    this.setState({ isOpen: true }, () => {
                        this.setState({ opacity: 1 }, () => {

                            if (!this.optimized) {
                                this.getBounding()
                            }
                        })
                    })
                }

            })
        }
    }
    handleChange = (e) => {
        let color = e.hex
        if (color != 'transparent') {
            color = color + Math.round(e.rgb.a * 255).toString(16)
        }
        let data = this.props.data ?? {}

        data[this.state.current] = color
        // console.log(data)
        // this.setState({ color })
        this.props.changeValue(this.props.header.key, data, this.props.extra,)

    }


    chooseFontColor(rawcolor) {
        let color = "#fff"
        if (rawcolor) {
            if (isNaN(Number(rawcolor[1])) || isNaN(Number(rawcolor[3])) || isNaN(Number(rawcolor[5]))) {
                color = "#000"
            }
            if (!isNaN(Number(rawcolor[7])) && Number(rawcolor[7]) < 6) {
                color = "#000"
            }
        }


        return color
    }



    render() {

        return (
            <div className='' style={{ zIndex: this.props.zIndex ?? null, }}>

                <div ref={el => this.currentNode = el} className="w-100 h-100 flexc" >
                    <button onClick={this.handleClick} className={"flexcc p-0 text-start"} style={{ minHeight: '20px', width: '100%', }}>

                        {this.props.data ? (
                            <div className='flexc w-100'>
                                <div className='mrd-2'>
                                    <div className='flexcc px-2' style={{ backgroundColor: this.props.data.background ?? '#fff', color: this.props.data.text ?? '#000', border: '1px solid #eee', height: 26, minWidth: 26, borderRadius: 6 }}>
                                        <p className='text-smaller text-semibold' style={{ lineHeight: 1 }}>{translate("Preview")}</p>
                                    </div>
                                </div>
                                {/* <p className='w-100' style={{ color: '#000' }}>{this.props.data?.color}</p> */}
                            </div>
                        ) : (
                            <p className='placeholder w-100' >{checkTranslation(this.props.header?.information?.placeholder ?? translate('Choose ...'))}</p>
                        )}
                    </button>
                </div >
                {this.state.opened && (
                    <div style={{ position: 'fixed', top: 0, left: 0, height: '100vh', width: this.props.width, }}>

                    </div>
                )}

                <div ref={el => this.view = el} className="" style={{}}>



                    <FixedView onHide={() => this.setState({ opened: false })} ref={(el) => (this.colorPicker = el)} nodeRef={this.currentNode} showFocus={false} zIndex={10} topOffset={5} xOffset={-10} bottomOffset={30} width={225}>
                        <>
                            {/* {this.props.opened && (
                                <div onClick={() => this.hideView()} style={{ pointerEvents: 'all', backgroundColor: '#00051050', height: '100%', top: 0, left: 0, position: 'fixed' }}>
                                </div>
                            )} */}

                            <div className='w-100 br-8' ref={el => this.content = el} style={{ border: '1px solid #eee', pointerEvents: 'all', background: '#fff', fontSize: '10px' }}>
                                <div className='w-100 pt-2  ' style={{}}>
                                    {/* <div className='px-2 flexc'>
                                        <div className='br-20 px-2 py-1' style={{ color: '#fff', background: '#007aff' }}>
                                            <p className='text-smaller'>Preview</p>
                                        </div>
                                    </div> */}
                                    <div className='flexc w-100 mb-1 px-2' style={{userSelect:'none'}}>

                                        <div className='pb-1 text-smaller mrd-3' style={{ color: this.state.current == 'background' ? '#007aff' : null, cursor: 'pointer' }} onClick={() => this.setState({ current: "background" })} >
                                            <p className='text-semibold text-small'>{translate("Background")}</p>
                                        </div>

                                        <div className='pb-1 text-smaller' style={{  color: this.state.current == 'text' ? '#007aff' : null, cursor: 'pointer' }} onClick={() => this.setState({ current: "text" })} >
                                            <p className='text-semibold text-small'>{translate("Text")}</p>
                                        </div>
                                    </div>
                                    {/* <div style={{}} onClick={this.handleClose} /> */}
                                    <ChromePicker color={this.props.data ? this.props.data[this.state.current] : '#fff'} onChange={this.handleChange} />
                                </div>
                            </div>


                        </>
                    </FixedView>

                </div>
            </div >
        )
    }
}

export default AdvancedColorInput;